import { render, staticRenderFns } from "./PaymentFormComponent.vue?vue&type=template&id=08d76bfb"
import script from "./PaymentFormComponent.vue?vue&type=script&lang=js"
export * from "./PaymentFormComponent.vue?vue&type=script&lang=js"
import style0 from "./PaymentFormComponent.vue?vue&type=style&index=0&id=08d76bfb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports